var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import './loadingIndicatorStyle.css';
import { valueFrom } from './loadingIndicatorUtils';
export function LoadingIndicator(_a) {
    var { size = 'medium', color = 'primary', ariaLabel = 'Loading' } = _a, props = __rest(_a, ["size", "color", "ariaLabel"]);
    const value = valueFrom(size);
    const circleStyle = {
        background: `var(--color-${color})`,
        height: value,
        width: value,
    };
    return (React.createElement("div", Object.assign({ "aria-label": ariaLabel, role: "status", "aria-atomic": "true", "aria-busy": "true", "aria-live": "polite", className: "loading-indicator" }, props),
        React.createElement("div", { className: "loading-indicator-circle", style: circleStyle }),
        React.createElement("div", { className: "loading-indicator-circle", style: circleStyle }),
        React.createElement("div", { className: "loading-indicator-circle", style: circleStyle })));
}
